import {Layers, WalkOfShameLayers} from "../../../view/WalkOfShameLayers";
import {TimelineLite} from "gsap";
import {WalkOfShame} from "../../../WalkOfShame";
import {WalkOfShameHelper} from "../../../../core/utils/WalkOfShameHelper";

export class BigWinView extends PIXI.Container {
    private _textures: PIXI.Texture[] = [];
    private _rot: number[] = [-0.12, -0.12, -0.16, -0.16, -0.17];
    private _bg: PIXI.Sprite;
    private _image: PIXI.Sprite;
    private _wreckingBall: PIXI.spine.Spine;
    private _whiteFlash: PIXI.Sprite;
    private _cam: PIXI.Sprite;
    private _titles: PIXI.spine.Spine[] = [];
    private _titleTl: TimelineLite | null;

    constructor() {
        super();

        WalkOfShameLayers.getLayer(Layers.BIG_WIN)!.addChild(this);
        this.init();
    }

    public getLevelAnimation(level: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        if (level === 4) {
            tl.add(() => {
                this._wreckingBall.visible = true;
                this._wreckingBall.updateTransform();
                this._wreckingBall.state.setAnimation(0, "animation", false);

                this._image.visible = false;
                this._cam.visible = false;

                this.killTitleTl();

                this._titles[level - 1].visible = false;
                this._titles[level - 1].state.clearTracks();

                this.playTitle(level);
            });
        } else if (level > 0) {
            tl.add(() => {
                this._whiteFlash.rotation = this._rot[level];
                this._whiteFlash.width = this._image.width;
                this._whiteFlash.height = this._image.height;

                this._whiteFlash.alpha = 0.38;
                this._whiteFlash.visible = true;

                this.killTitleTl();

                this._titles[level - 1].visible = false;
                this._titles[level - 1].state.clearTracks();

                this.playTitle(level);
            });
            tl.add(() => {
                this._whiteFlash.alpha = 1;
            }, 2 / 30);
            tl.add(() => {
                this._whiteFlash.alpha = 0.38;
            }, 4 / 30);
            tl.add(() => {
                this._whiteFlash.alpha = 1;
            }, 6 / 30);
            tl.add(() => {
                this._whiteFlash.alpha = 0.38;
            }, 8 / 30);
            tl.add(() => {
                this._whiteFlash.alpha = 1;
            }, 10 / 30);
            tl.add(() => {
                this._image.texture = this._textures[level];
                this._image.rotation = this._rot[level];

                this._whiteFlash.visible = false;
            }, 12 / 30);
        } else {
            tl.add(() => {
                this._image.texture = this._textures[level];
                this._image.rotation = this._rot[level];

                this.playTitle(level);
            });
        }

        if (!this.visible) {
            tl.add(() => {
                this.alpha = 0;
                this.visible = true;

                this._image.visible = true;
                this._cam.visible = true;
            });
            tl.to(this, {
                duration: 0.3,
                alpha: 1
            });
        }

        return tl;
    }

    public playEnding(): void {
        const tl: TimelineLite = new TimelineLite();

        tl.to(this, {
            duration: 0.3,
            alpha: 0
        });
        tl.add(() => {
            this.visible = false;
            this.alpha = 1;

            this._wreckingBall.visible = false;
            this._wreckingBall.state.clearTracks();

            this.killTitleTl();
            this._titles.forEach((title: PIXI.spine.Spine) => {
                title.visible = false;
                title.state.clearTracks();
            });
        });
    }

    private init(): void {
        this.visible = false;

        const titleNames: string[] = ["just-a-sip", "tipsy", "filthy", "wasted", "wrecked"];
        let texture: PIXI.Texture,
            title: PIXI.spine.Spine;

        this._bg = new PIXI.Sprite(WalkOfShame.assetLoader.getTextures("Bigwin/bg")[0]);
        this._bg.anchor.set(0.5);
        this._bg.position.set(360);

        this._image = new PIXI.Sprite();
        this._image.anchor.set(0.5);
        this._image.position.set(330, 350);

        this._wreckingBall = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("wreckingBall"));
        this._wreckingBall.visible = false;
        this._wreckingBall.position.set(360);

        this._whiteFlash = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._whiteFlash.anchor.set(0.5);
        this._whiteFlash.position.set(330, 350);
        this._whiteFlash.visible = false;

        this._cam = new PIXI.Sprite(WalkOfShame.assetLoader.getTextures("Bigwin/cam")[0]);
        this._cam.anchor.set(0.5);
        this._cam.position.set(360);

        this.addChild(this._bg, this._image, this._wreckingBall, this._whiteFlash, this._cam);

        for (let ctr: number = 1; ctr < 6; ctr++) {
            texture = WalkOfShame.assetLoader.getTextures("Bigwin/Bigwin_Level_0" + ctr)[0];
            this._textures.push(texture);

            title = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset(titleNames[ctr - 1]));
            title.visible = false;
            title.position.set(360, 85);

            this.addChild(title);
            this._titles.push(title);
        }
    }

    private playTitle(level: number): void {
        const title: PIXI.spine.Spine = this._titles[level];
        title.visible = true;
        title.updateTransform();
        this._titleTl = WalkOfShameHelper.createTimelineForAnimation(title, 0, "appear", false).eventCallback("onComplete", () => {
            this.killTitleTl();

            this._titleTl = WalkOfShameHelper.createTimelineForAnimation(title, 0, "hover", true);
        });
    }

    private killTitleTl(): void {
        if (this._titleTl) {
            this._titleTl.pause();
            this._titleTl.kill();
            this._titleTl = null;
        }
    }
}